package com.milta.core.localization.translations.bg

import com.milta.core.localization.AdminPromptsStrings

internal val AdminPrompts = AdminPromptsStrings(
    loading = "Зареждане…",
    errorNoConnection = "Сървърът не може да бъде достигнат — провери връзката си.",
    errorGeneric = "Възникна грешка. Опитай отново по-късно.",
    contractLockedNotice = "🔒 Изходният договор (JSON формат) остава заключен — добавя се автоматично от сървъра след редактирания текст, за да не се повреди извличането в продукция.",
    notModifiedLabel = "Стойност по подразбиране — никога не е променяна",
    modifiedOnPrefix = "Променен на",
    resetToDefaultAction = "↺ Връщане към стойностите по подразбиране",
    editableBodyLabel = "✏️ Редактируемо съдържание — бизнес правила",
    markdownBoldSnippet = "**удебелен текст**",
    markdownItalicSnippet = "*курсив текст*",
    markdownCodeSnippet = "`код`",
    markdownHeadingSnippet = "## Заглавие",
    markdownBulletSnippet = "- елемент от списък",
    markdownNumberedSnippet = "1. елемент от списък",
    markdownQuoteSnippet = "> цитат",
    previewToggleEdit = "✏️ Редактирай",
    previewToggleShow = "👁 Преглед",
    contractFooterLabel = "🔒 Изходен договор — заключен, добавен автоматично",
    actionErrorOffline = "Неуспешно — провери връзката си.",
    actionErrorGeneric = "Записването неуспешно, опитай отново.",
    unsavedChangesNotice = "● Незапазени промени",
    savingAction = "Запазване…",
    saveAction = "Запази промените",
)
